// extracted by mini-css-extract-plugin
export default {"orderList":"OrderList_orderList__hR11n"};